import * as EntityTypes from '../constants/entityTypes';
import AudienceAPIMapper from '../mappings/AudienceAPIMapper';
import ButtonAPIMapper from '../mappings/ButtonAPIMapper';
import CampaignAPIMapper from '../mappings/CampaignAPIMapper';
import ConnectionAPIMapper from '../mappings/ConnectionAPIMapper';
import EntryAPIMapper from '../mappings/EntryAPIMapper';
import EntryButtonAPIMapper from '../mappings/EntryButtonAPIMapper';
import PromoterAPIMapper from '../mappings/PromoterAPIMapper';
import TriggerAPIMapper from '../mappings/TriggerAPIMapper';
import WidgetAPIMapper from '../mappings/WidgetAPIMapper';

class APIMapController {
  constructor(mappersConfig = []) {
    this.entityToAPIMap = new Map(mappersConfig);
  }

  perform(change) {
    const {
      item: { entityType },
    } = change;
    const entityAPIMapper = this.entityToAPIMap.get(entityType);
    return entityAPIMapper.perform(change);
  }
}

const apiMapConfig = [
  [EntityTypes.WIDGET, WidgetAPIMapper],
  [EntityTypes.TRIGGER, TriggerAPIMapper],
  [EntityTypes.BUTTON, ButtonAPIMapper],
  [EntityTypes.ENTRY, EntryAPIMapper],
  [EntityTypes.ENTRY_BUTTON, EntryButtonAPIMapper],
  [EntityTypes.AUDIENCE, AudienceAPIMapper],
  [EntityTypes.PROMOTER, PromoterAPIMapper],
  [EntityTypes.CONNECTION, ConnectionAPIMapper],
  [EntityTypes.CAMPAIGN, CampaignAPIMapper],
];

export default new APIMapController(apiMapConfig);
